/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('DOMContentLoaded', function () {
  var contactForm = document.querySelector('#contact_form');
  if (!contactForm) return;

  contactForm.addEventListener('submit', function (e) {
    e.preventDefault();

    var submitBtn = contactForm.querySelector('[type="submit"]');
    var originalText = submitBtn ? submitBtn.textContent : null;
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Wysyłanie...';
    }

    var data = {
      from_name: contactForm.querySelector('[name="contact[name]"]')?.value || '',
      from_email: contactForm.querySelector('[name="contact[email]"]')?.value || '',
      message: contactForm.querySelector('[name="contact[body]"]')?.value || ''
    };

    emailjs.send('service_4p2sv9g', 'template_zfra4eo', data)
      .then(function () {
        contactForm.innerHTML = '<p class="form-success">Dziękujemy! Twoja wiadomość została wysłana.</p>';
      })
      .catch(function (error) {
        console.error('EmailJS error:', error);
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = originalText;
        }
        alert('Wystąpił błąd podczas wysyłania. Spróbuj ponownie.');
      });
  });
});